import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqLog = {
	listPaginate: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/log", {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	update: async function (ativo, uuid) {
		return apiServer
			.patch(
				"portal/v1/log",
				{ ativo, uuid },
				{
					headers: {
						banco,
					},
				}
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqLog;
